import { Link } from 'wouter';

// Client-side twin of server/pages/notFound.ts, for a link inside the app that leads nowhere.
// It replaces the old redirect to "/", which hid broken links behind the homepage.
export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#F0F2F5] px-4 py-12">
      <div className="max-w-xl mx-auto card p-6">
        <h1 className="text-xl font-bold text-gray-900 mb-2">Page not found</h1>
        <p className="text-gray-500 mb-4">This page does not exist, or the listing is no longer public.</p>
        <Link href="/">
          <span className="inline-flex items-center min-h-[44px] px-4 rounded-lg bg-castle-500 text-white font-semibold cursor-pointer">
            Browse listings
          </span>
        </Link>
      </div>
    </div>
  );
}
